import React from 'react';
import 'antd/dist/antd.css';
import { Button, Col, Row, Space, Popover } from "antd";
import ReportAllPopup from "../../ReportAllPopup/index";
import ReportMissingPopup from "../../ReportMissingPopup/index";
import ReportIcon from "../../../../../assets/report.png";
import CommonConfig from '../../../../commonConfig.json';
import "../common.css";
// import { setPopupOpen, setPopupMatrixStatus } from '../../../../../store/actions/popupStatusAction';

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

let compliancePopupDetail = CommonConfig.compliancePopupDetail;

let cellType = CommonConfig.cellType;

class ReportCell extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: props.idKey,
      reportMissingPopUpRight: false,
      reportAllPopUpRight: false,

    }

  }

  getCellType = (key) => {
    return cellType[key] || 'TEXT';
  }

  reportMissingRightPopUp() {
    this.setState({ reportMissingPopUpRight: !this.state.reportMissingPopUpRight });
  }

  reportAllRightPopUp() {
    this.setState({ reportAllPopUpRight: !this.state.reportAllPopUpRight });
  }

  onHide = (val) => {
    this.setState({
      reportMissingPopUpRight: val,
      reportAllPopUpRight: val
    })
  }

  render() {
    if(this.props.status.nonCompliant){
      this.state.reportMissingPopUpRight = false;
      this.state.reportAllPopUpRight = false;
    }

    var report_ratio_string = this.props.status.reportUploadedRatio;
    var temp = report_ratio_string.split('/');

    let cellFiller = "";
    if (['TEXT', 'EXPIRED', 'HOTEL_TZ_NOT_REACHED', 'HOTEL_NOT_LIVE',
      'HOTEL_SOFT_LIVE', 'HOTEL_SIG_NOT_LIVE', 'AWAITING_SIG_TRIGGER']
      .includes(this.getCellType(this.props.status.type))) {
      cellFiller = <span style={{ color: (this.props.status.style.color !== undefined) ? this.props.status.style.color : 'white' }}>{(this.props.status.text !== undefined) ? this.props.status.text : ""}</span>;
    } else {
      
      if (['MISSING'].includes(this.getCellType(this.props.status.type))) {
        cellFiller =
          <ReportMissingPopup
            reportContent={this.props.reportContent}
            visible={this.state.reportMissingPopUpRight}
            // visible={reportPopupStatus.reportMissingPopUpRight}
            onHide={this.onHide}
            // placement={"top"}
            bdate={this.props.idKey.split(':')[1]}
            hname={(this.props.idKey.split(':')[2] === "Generic")?this.props.idKey.split(':')[0]:this.props.idKey.split(':')[3]}
            innerContent={<div className="cellPointer reportCount" >
              <Button
                onClick={() => this.reportMissingRightPopUp()} type="primary" size="small" style={{ fontSize: '11px' }}>
                {(this.props.status.text !== undefined) ? this.props.status.text : ""}
              </Button>
            </div>}
          />
      } else if (['UPLOAD'].includes(this.getCellType(this.props.status.type))) {
        cellFiller = <Button onClick={() => { window.open(this.props.status.link, "_blank"); }} type="primary" size="small" style={{ fontSize: '11px' }}>{(this.props.status.text !== undefined) ? this.props.status.text : ""}</Button>;
      }
    }

    let centerComponent = "";
    if (this.props.status.tooltip !== undefined) {
      if (this.props.status.plainCell === undefined) {
        centerComponent = <Col className="cell-middle-content" span={18}>
          <Col >
            <Popover
              className="cellPointer"
              content={this.props.status.tooltip}
              title=""
              placement="top"
              trigger="click"
              arrowPointAtCenter>
              {cellFiller}
            </Popover>
          </Col>
        </Col>

      } else {
        centerComponent = <Popover
          className="cellPointer"
          content={this.props.status.tooltip}
          title=""
          placement="top"
          trigger="click" 
          arrowPointAtCenter>
          <Col className="cell-middle-content plain-cell" span={22}>
            <Col>
              {cellFiller}
            </Col>
          </Col>
        </Popover>
      }

    } else {
      if (this.props.status.plainCell !== undefined) {
        centerComponent = <Col className="cell-middle-content plain-cell" span={22}>
          <Col>
            {cellFiller}
          </Col>
        </Col>

      } else {
        centerComponent = <Col className="cell-middle-content" span={18}>
          <Col >
            {cellFiller}
          </Col>
        </Col>
      }
    }

    let uploadedCount = parseInt(temp[0]);
    let leftComponent = (<Col className="cell-start-content" span={3}>
      <Space direction="vertical">
        <Row><Col span={24}>
          {(uploadedCount > 0 && this.props.compMyDocsNav) ? (
            <span onClick={() => { window.open(this.props.mydocsURL, "_blank"); }} className="cellPointer">
              <img src={ReportIcon} className="reportIcon" alt="reportIcon"/>
            </span>
          ) : (<>&nbsp;</>)}
        </Col></Row>
        <Row><Col span={24}><div>&nbsp;</div></Col></Row>
      </Space>
    </Col>);

    let rightComponent = (<Col className="cell-end-content" span={3}>
      <Space direction="vertical">
        <Row><Col span={24}><div>&nbsp;</div></Col></Row>
        <Row>
          {(this.props.compReportsPopupDetails === compliancePopupDetail.ALL) ? (
            <Col span={24} onClick={() => this.reportAllRightPopUp()}>
              <ReportAllPopup
                reportContent={this.props.reportContent}
                visible={this.state.reportAllPopUpRight}
                onHide={this.onHide}
                bdate={this.props.idKey.split(':')[1]}
                hname={(this.props.idKey.split(':')[0] !== '' && this.props.idKey.split(':')[3] !== '') ? (this.props.idKey.split(':')[3]+" - "+this.props.idKey.split(':')[0]) : ((this.props.idKey.split(':')[2] === "Generic")?this.props.idKey.split(':')[0]:this.props.idKey.split(':')[3])}
                // visible={reportPopupStatus.reportAllPopUpRight}
                innerContent={<div className="cellPointer reportCount">{this.props.status.reportUploadedRatio}</div>}
              />
            </Col>
          ) : (
            (this.props.reportContent.mis_reports.find(report => report.type = 'missing')) ? (
              <Col span={24} onClick={() => this.reportMissingRightPopUp()}>
                <ReportMissingPopup
                  reportContent={this.props.reportContent}
                  visible={this.state.reportMissingPopUpRight}
                  onHide={this.onHide}
                  bdate={this.props.idKey.split(':')[1]}
                  hname={(this.props.idKey.split(':')[0] !== '' && this.props.idKey.split(':')[3] !== '') ? (this.props.idKey.split(':')[3]+" - "+this.props.idKey.split(':')[0]) : ((this.props.idKey.split(':')[2] === "Generic")?this.props.idKey.split(':')[0]:this.props.idKey.split(':')[3])}
                  // visible={reportPopupStatus.reportMissingPopUpRight}
                  innerContent={<div className="cellPointer reportCount" >{this.props.status.reportUploadedRatio}</div>}
                />
              </Col>
            ) : (
              <Col span={24} >
                <div style={{ color: 'white' }}>{this.props.status.reportUploadedRatio}</div>
              </Col>
            )
          )}
        </Row>
      </Space>
    </Col>)

    if (this.props.status.plainCell !== undefined) {
      leftComponent = (<Col className="cell-start-content" span={1}>
        <Space direction="vertical">
          <Row><Col span={24}><div style={{ height: '21px' }}></div></Col></Row>
          <Row><Col span={24}><div style={{ height: '21px' }}></div></Col></Row>
        </Space>
      </Col>);
      rightComponent = (<Col className="cell-start-content" span={1}>
        <Space direction="vertical">
          <Row><Col span={24}><div style={{ height: '21px' }}></div></Col></Row>
          <Row><Col span={24}><div style={{ height: '21px' }}></div></Col></Row>
        </Space>
      </Col>);
    }

    let cellGradient = {
      height: '50px',
      backgroundColor: this.props.status.style['background-color']
    }

    if (!isNaN(temp[0] / temp[1])) {
      cellGradient["backgroundImage"] = `linear-gradient(to right, #338E4D ${(temp[0] / temp[1]) * 100}%, ${this.props.status.style['background-color']} ${(temp[0] / temp[1]) * 100}%)`;
    }
    if (this.props.status.gradient !== undefined && this.props.status.gradient === false) {
      delete cellGradient.backgroundImage;
    }

    return (
      <div>
          <Row style={cellGradient}>
            {leftComponent}
            {centerComponent}
            {rightComponent}
          </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let compPermissions = state.appPermissionsReducer.compliancePermissions;
  return {
    compReportsPopupDetails: compPermissions.compReportsPopupDetails,
    compMyDocsNav: compPermissions.compMyDocsNav,
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ReportCell);